export const kebabCase = (s: string) => s?.toLowerCase().replace(/ /g, "-");
